function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#content-curator_svg__clip0_4607_44073)",
  stroke: "currentColor",
  strokeWidth: 3,
  strokeMiterlimit: 10
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.875 13.125h7.5M11.875 20.625h7.5M11.875 28.125h3",
  strokeLinecap: "square"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.875 1.875v10h10"
}), /*#__PURE__*/React.createElement("path", {
  d: "M38.125 38.125l-4.331-4.331M29.375 35.625a6.25 6.25 0 100-12.5 6.25 6.25 0 000 12.5z",
  strokeLinecap: "square"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.5 18.75v-7.5l-10.385-10H3.75v37.5h16.923",
  strokeLinecap: "square"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "content-curator_svg__clip0_4607_44073"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h40v40H0z"
})));

var SvgContentCurator = function SvgContentCurator(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    color: "#4038ff"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgc3R5bGU9ImNvbG9yOiM0MDM4RkY7IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8ZyBjbGlwLXBhdGg9InVybCgjY2xpcDBfNDYwN180NDA3MykiPgo8cGF0aCBkPSJNMTEuODc1IDEzLjEyNUgxOS4zNzUiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjMiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSIvPgo8cGF0aCBkPSJNMTEuODc1IDIwLjYyNUgxOS4zNzUiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjMiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSIvPgo8cGF0aCBkPSJNMTEuODc1IDI4LjEyNUgxNC44NzUiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjMiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSIvPgo8cGF0aCBkPSJNMjYuODc1IDEuODc1VjExLjg3NUgzNi44NzUiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjMiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIvPgo8cGF0aCBkPSJNMzguMTI1MiAzOC4xMjVMMzMuNzkzOSAzMy43OTM3IiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIzIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS1saW5lY2FwPSJzcXVhcmUiLz4KPHBhdGggZD0iTTI5LjM3NSAzNS42MjVDMzIuODI2OCAzNS42MjUgMzUuNjI1IDMyLjgyNjggMzUuNjI1IDI5LjM3NUMzNS42MjUgMjUuOTIzMiAzMi44MjY4IDIzLjEyNSAyOS4zNzUgMjMuMTI1QzI1LjkyMzIgMjMuMTI1IDIzLjEyNSAyNS45MjMyIDIzLjEyNSAyOS4zNzVDMjMuMTI1IDMyLjgyNjggMjUuOTIzMiAzNS42MjUgMjkuMzc1IDM1LjYyNVoiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjMiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSIvPgo8cGF0aCBkPSJNMzcuNSAxOC43NVYxMS4yNUwyNy4xMTU0IDEuMjVIMy43NVYzOC43NUgyMC42NzMxIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIzIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS1saW5lY2FwPSJzcXVhcmUiLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF80NjA3XzQ0MDczIj4KPHJlY3Qgd2lkdGg9IjQwIiBoZWlnaHQ9IjQwIiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=";
export { SvgContentCurator as ReactComponent };